import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMetadata } from '../models/ApiMetadata/api-metadata';
import { ApiMetadataApi } from '../api/api-metadata-api';

@Injectable({
  providedIn: 'root',
})
export class ApiMetadataRepository {
  private apiMetadataApi = inject(ApiMetadataApi);

  private apiMetadata$?: Observable<ApiMetadata>;

  getApiMetadata(): Observable<ApiMetadata> {
    if (!this.apiMetadata$) {
      this.apiMetadata$ = this.apiMetadataApi.getApiMetadata();
    }
    return this.apiMetadata$;
  }
}
